import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails19 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery21.jpg";
    return (
        <>
         <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}


            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                    
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                           
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            રામદેવજી નાં લગ્ન
                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                    
                                                >
                                                    <span className="income">રામદેવજી નાં લગ્ન
                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    રણુંજા ગામના નરનારીઓ દરબારગઢમાં આનંદ ઓચ્છવ ઊજવી અ નીકળ્યો. ગામ બહાર આવી તેઓ વરવેલમાં બિરાજ્યા. ઢોલ, ગામો, મા માતા મિણલદેએ રામદેવજીને કુંકુમ તિલક કરી આશીર્વાદ આપ્યા અને વ વાગવા લાગ્યાં. જાનમાં જવા તૈયાર થયેલા સગાંસંબંધી ગાડા પર સવાર થઈ, અજમલરાય પધાર્યા. રામદેવજીએ હરભુજીને કહ્યું કે, ‘ભાઈ' ! તમે આ પ્રમા એટલામાં રામદેવજીની માસીના દીકરા હરભુજી, ભાઈ વીર,
                                                    જ બેસો.'
                                                    ‘પણ ભાઈ ! આ ગાડાને બળદ ક્યાં જોડ્યા છે ?' ‘તમે બેસો તો ખરા !' રામદેવે કહ્યું.
                                                    હરભુજી ગાડા પર બેઠા, ત્યાં જ ગાડું ચાલવા લાગ્યું.
                                                    વરવેલ, પાછળ લીલુડો ઘોડો, એની સાથે સાથે હરભુજીનું બળદ વગરનું ચ સૌ આશ્ચર્યમાં ગરક થઈ ગયા. જાન વિદાય થઈ. આગળ રામદેવન દોડવા લાગ્યું. જાન ઉમરકોટમાં આવી પહોંચી. જાનનું સામૈયું કરવા નગરજનો સીમાડે આવેલા હતા. તેઓ બળદ વગરના ગાડાને જોઈ આશ્ચર્યમાં પડયા. આ ચમત્કાર જોઈ રામદેવને સૌ કોઈ દેવપુરુષ માનવા લાગ્યું અને ‘રામદેવની જય’ખં ઘોષણા કરતાં બધાં રામદેવજીને પગે પડ્યાં.
                                                    સર્વત્ર આનંદ છવાઈ રહ્યો. સામૈયું કર્યા બાદ જાન ઉમરકોટમાં પ્રવેશી, જાનનો ઉતારો દરબારગઢમાં આપ્યો. નેતલદેની સખીઓ હાથમાં રૂમાલ ઢાંકેલો થાળ લઈને રામદેવજીની પાસે આવી. એક સખી બોલી :
                                                    ‘રાજકુમાર ! બધાં કહે છે કે તમે તો પીર છો ! પણ પીર તો મુસલમાનમાં હોય અને તમે તો હિંદુ છો ?'
                                                    ‘બહેન ! મક્કાના મોટા પીરને પરચો બતાવવાથી રામદેવજી હિંદવા પીરછે એમ મક્કાના પીરોએ કહ્યું હતું.' હરભુજીએ સમજણ પાડતાં કહ્યું.
                                                    ‘પીર જો પીરાઈ બતાવે તો માનીએ.' બીજી બોલી.

                                                </p>
                                                <p className="paragraph-content">
                                                    તુ જેવું છે ” હરભુજીએ પ્રશ્ન કર્યો, મ આ થાળનું ભોજન તો જમો ?'
                                                    રામદેવજીની મશ્કરી કરવા સખીઓએ મરેલી બિલાડીને થોળમાં મૂકી ઉપર
                                                    ઢાંકયો હતો.
                                                    રામદેવજીએ થાળને ઢાંકેલો રૂમાલ ઊંચક્યો ત્યાં તો મ્યાઉં મ્યાઉં” કરતી ભી જીવતી થઈ અને છલંગ મારી નાઠી, બધાં આશ્ચર્ય પામ્યાં. નેતલદેની જો ખસિયાણી પડી ગઈ ! અને મનમાં રામદેવજીની પીરાઈ કબૂલ કરી એમના
                                                    ચરણોમાં નમી પડી.
                                                    લગ્નનો સમય થઈ ગયો. રામદેવજી લગ્નમંડપમાં બેઠા, કન્યા પધરાવવાનો સચ થયો. સખીઓ નેતલદેને ખૂબ શણગારીને મંડપમાં લાવી અને હસ્તમેળાપની
                                                    વિધિ શરૂ થઈ.
                                                    ઉછરંગ રંગમાં આનંદ ઘણો રે, આવ્યો. રામદેવપીરનો વિવાય રે. પરગટ પરચો હિન્દવે પૂર્યો ને, કન્યા પદમણી થાય ૨. ઉછરંગ
                                                    હેતે ને પ્રીતે સોઢેમાંયરાં આદર્યા રે, હૈયે હરખ
                                                    આપાર રે.
                                                    લીલા રે વાસની ચોરીયું બાંધીને મંગલ
                                                    વરતાય ચાર રે. ઉછરંગ
                                                    પહેલું રે મંગલવતિયું ને, સોઢા દિયે રે કન્યાદાન .
                                                    બીજું રે મંગલ
                                                    આપ્યા
                                                    વરતિયું ને, ગરથ-ભંડાર
                                                    ૨. ઉછરંગ
                                                    હસ્તી ઘોડા ને વળી દાસદાસીઓ,
                                                    આપ્યા
                                                    તે નવલખ
                                                    ==
                                                    ત્રીજું
                                                    સાંભળ્યો
                                                    મંગલ બહેનીનો
                                                    હાર રે. કરતિયું રે,
                                                    પુકાર રે. ઉછરંગ


                                                </p>
                                                <p className="paragraph-content">
                                                    મંડપમાં
                                                    ન
                                                    શ્રી કાન માલ
                                                    તોડીને,
                                                    નાંખો ધારે લીલુડે પલાણ રે. સોઢા ઊભા અરજુ દાખવે રે,
                                                    કોને પીર અમારી કંઈ વાંક રે. ઉછરંગ,
                                                    શીખ આપોને સોઢાજી અમને રે,
                                                    જાવું મારે બહેનની વહારે રે.
                                                    પાઉં પલકમાં પહોંચ્યા રણુંજે.
                                                    બેનીએ સૂણ્યા સમાચાર ૨. ઉછરંગ
                                                    નેતલદે અષ્ટવંકી અને બેડોળ હોવા છતાં રામદેવજીની તેના ઉપર અમીદ થતાં તે સ્વરૂપવાન બની ગઈ ! આ કાયાપલટ જોઈ સોઢારાજા અને પ્રજ્જાનો
                                                    હર્ષઘેલાં બની ગયાં.
                                                    અહીં રણુંજામાં સગુણાનો પાંચ વર્ષનો બાળક બે દિવસની માંદગી ભોગવી મરણ પામ્યો. સગુણા રામદેવજીને સંભારી રોવા લાગી. રણુજામાં હાહાકા વરતાયો, સગુણાને પોતાની સાસુનાં કહેલાં વચનો યાદ આવ્યાં.
                                                    ‘જાઓ છો ભર્યાં ને વહુજી ! આવશો ઠાલાં જી રે, અને ઠોર નહિ પામો ઠકરાઈ રે.
                                                    આ સાસુના કહેલા શબ્દો સંભારી સંભારીને સગુણા હૈયાફાટ રુદન કરતી રામદેવજીને આરાધવા લાગી. તેના મનની મનમાં રહી ગઈ. હવે હું પોતે સાસરિયાને શી રીતે મોઢું બતાવી શકીશ ? પીંગલગઢમાં હવે શી રીતે પગ મૂકી શકીશ ? આવી રીતે કલ્પાંત કરતી તે રામદેવને યાદ કરવા લાગી.
                                                    રામદેવજીએ બહેન સગુણાનો પુકાર સાંભળ્યો અને લગ્નમંડપમાંથી વરમાળા તોડી ઊભા થઈ ગયા. હરભુજીને લીલુડો ઘોડો તૈયાર કરવા કહ્યું. સોઢારાજ આ જોઈને સ્તબ્ધ બની ગયા અને પૂછ્યું કે, ‘અમારો કાંઈ વાંકગુનો છે કે તમે લગ્નમંડપમાંથી ઊભા થઈ ગયા ?’
                                                    રામદેવજી બોલ્યા : ‘સોઢારાજા ! તમારો કંઈ પણ વાંક નથી, પરંતુ મારી બેન સગુણા અત્યારે રણુંજામાં રડી રહી છે. તે અત્યારે ઘણી જ દુઃખમાં છે, માટે મારે અત્યારે જ રણુંજા જવું પડશે. જો અમને જાન સાથે વિદાય આપો તો ઘણું સારું.’ સોઢારાજે તરત જાનને શીખ આપી, નેતલદેને વેલમાં બેસાડી જાનને
                                                    વિદાયગીરી દીધી.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails19;
